export default __webpack_public_path__ + "static/media/img-doc-error.01a03358.svg";